import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7e61d5ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "success-icon"
};
const _hoisted_2 = {
  key: 0,
  class: "main-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "您已成功将公众号和 JoinMC 账户关联系统将按照您客服推送规则，向您推送具体的通知。", -1));
const _hoisted_4 = {
  key: 1,
  class: "main-content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "感谢您成功注册 JoinMC 平台！现在，您可以在电脑端尽享 JoinMC 的完整功能，也可以在手机端使用基础的 AI 功能。", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "电脑端登录地址：joinmc.cn", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "我们期待您的使用，并祝您体验愉快！", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "此外，您的公众号已成功与 JoinMC 账户关联。系统将根据您的客服推送规则，向您发送相关通知。", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_icon, {
    name: "checked"
  })]), _ctx.$route.query.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createVNode(_component_van_button, {
    type: "primary",
    round: "",
    to: "/"
  }, {
    default: _withCtx(() => [_createTextVNode("去对话")]),
    _: 1
  })])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _hoisted_6, _hoisted_7, _hoisted_8, _createVNode(_component_van_button, {
    type: "primary",
    round: "",
    to: "/"
  }, {
    default: _withCtx(() => [_createTextVNode("去对话")]),
    _: 1
  })]))], 64);
}